import { useSlaMetrics } from '../../hooks/use-analytics';
import { Skeleton } from '../ui/skeleton';

function ms(v: number | null): string {
  if (v === null) return '—';
  const s = Math.round(v / 1000);
  return s < 60 ? `${s} с` : `${Math.round(s / 60)} мин`;
}

function pct(v: number | null): string {
  return v === null ? '—' : `${Math.round(v * 100)}%`;
}

export function SlaWidget() {
  const { data, isLoading, isError } = useSlaMetrics({});

  if (isLoading) return <Skeleton className="h-40 w-full" />;
  if (isError) return <div className="text-sm text-red-600">Не удалось загрузить метрики SLA.</div>;
  if (!data) return null;

  const cards = [
    { label: 'Диалогов за период', value: data.dialogsInPeriod },
    { label: 'С передачей человеку', value: `${data.dialogsWithHandoff} (${pct(data.shareWithHandoff)})` },
    { label: 'Нарушений SLA', value: `${data.violations} (${pct(data.violationRate)})` },
    { label: 'Медиана ответа', value: ms(data.medianResponseMs) },
    { label: 'P90 ответа', value: ms(data.p90ResponseMs) },
  ];

  return (
    <div className="rounded border border-border p-4">
      <h2 className="mb-3 font-semibold">SLA</h2>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
        {cards.map((c) => (
          <div key={c.label} className="rounded bg-muted/40 p-2 text-center">
            <div className="text-lg font-semibold">{c.value}</div>
            <div className="text-xs text-muted-fg">{c.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
